import React from 'react';

export default function CustomerStory() {
  return (
    <section aria-labelledby="customer-story-title" className="border-y border-[#244A49]/15 bg-white px-6 py-16 sm:py-20">
      <div className="mx-auto grid max-w-6xl gap-8 md:grid-cols-[1fr_1.618fr] md:gap-14">
        <div>
          <p className="font-michroma text-xs uppercase tracking-widest text-[#244A49]">The story is already there</p>
          <h2 id="customer-story-title" className="mt-5 text-3xl font-bold leading-tight text-[#101F1F] sm:text-4xl">A good review should be the beginning of the story.</h2>
        </div>
        <div className="space-y-5 text-lg leading-8 text-[#244A49]">
          <p>Your clients earn trust through the work they do. Customers tell you what mattered: the clear explanation, the extra care, the problem finally solved.</p>
          <p>Too often, those words stay on a review page while the next article or social post starts from a blank screen. The business has a story worth telling. Your agency needs a practical way to carry it forward.</p>
          <p className="font-semibold text-[#101F1F]">Start with what customers already value. Use it to shape the replies, articles, and posts that help the next person understand why this business is worth considering.</p>
        </div>
      </div>
    </section>
  );
}